import React from "react";

const Form = ({
  className,
  style,
  onClick,
  onDoubleClick,
  onMouseOver,
  onMouseOut,
  children,
  layerRef
}) => {
  return (
    <form
      ref={layerRef}
      className={className}
      style={style}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {children}
    </form>
  );
};

export default Form;
